import i18n from '@/i18n';
import { DataType, FilterType } from '@colven/common-domain-lib/lib';

export const PIMS_LOGS_HEADERS = [
    {
        text: i18n.t('pimsLogs.table.truckCode'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'CodigoCamion',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.codeThing'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'CodigoEquipo',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.driverCode'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'CodigoChofer',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.harvestFrontCode'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'CodigoFrenteCosecha',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.trapicheCode'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'CodigoTrapiche',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.codeFinca'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'CodigoFinca',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.driveUnitCode'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'CodigoUnidadManejo',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.stepCode'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'CodigoEtapa',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.stepDate'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'FechaHoraEtapa',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.latitude'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'Latitud',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.longitude'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'Longitud',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.indentication'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'Identificacion',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.recordDate'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'FechaHoraGrabacion',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.integrationDate'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'FechaHoraIntegracion',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('pimsLogs.table.situation'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'Situacion',
        spinner: false,
        width: 200,
    },
    {
        text: 'Resumen Origen',
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'ResumenOrigen',
        spinner: false,
        width: 200,
    }
]
